import { Box } from '@chakra-ui/react'
import React from 'react'
import Assignment from '../components/Assignment'

const AssignmentScreen = () => {
  return (
    <Box>
      <Assignment/>
    </Box>
  )
}

export default AssignmentScreen
